import React, { useState } from 'react';
import './Card.css'
import VideoPlayer from "./VideoPlayer.js";

export default function Card(props)
{
    const [divHeight, setDivHeight] = useState('130px'); // Estado para la altura del div

    // Función para cambiar la altura del div al hacer clic
    const handleClick = () => {
      setDivHeight(divHeight === '130px' ? props.video!==null?'500px':"220px": '130px');
    };

    return(

        <section className="Tarjeta" style={{ height: divHeight, overflow: "hidden" }}
       >
         <div onClick={handleClick}>
         <img className="LogoEquipo" src={props.logoequipo}/>
        <div className="Equipo">{props.equipo}</div>
        {/* <div className="Goles">{props.goles}</div> */}
        {/* <img className="EquipoVisitante" src={props.logovisitante}/> */}
        <div className="Rival">vs {props.rival}</div>
        {/* <div className="Resultado">{props.resultado}</div> */}
        <div className="Fecha">{props.fecha}</div>
        <div className="Temporada">{props.temporada}</div>
        <div className="Competicion">{props.competicion}</div>
        {/* <div className="Fase">{props.fase}</div> */}
        {/* <div className="Condicion">{props.condicion}</div> */}
        <div className="Minutos">{props.minutos} Minutos</div>
        <div className="Gol">{props.gol} Goles</div>
        <div className="Asistencias">{props.asistencias} Asistencias</div>
         </div>
         <div>
           {props.video?<VideoPlayer video={props.video}/>:null}
         </div>
        </section>
    
     )
}